import React, { useCallback } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PriceSection } from './components/PriceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
const CHECKOUT_URL = 'https://libres-de-ser.impultienda.ar/checkout';
export function App() {
  const handleCheckout = useCallback(() => {
    window.location.assign(CHECKOUT_URL);
  }, []);
  return <div className="min-h-full w-full bg-white font-sans text-ink" data-id="element-0" data-mp="31ayplzmqfjy8">
      <Hero data-id="element-1" data-mp="2wk0ah3dhcrwk" />
      <main data-id="element-2" data-mp="2wjgqzi86lvgf">
        <PainSection data-id="element-3" data-mp="2wjqft2hhpwkj" />
        <BenefitsSection data-id="element-4" data-mp="2wiferaffj2x4" />
        <PriceSection onBuy={handleCheckout} data-id="element-5" data-mp="2whxcnx635uha" />
        <TestimonialsSection data-id="element-6" data-mp="28tme50nv46w6" />
        <FaqSection data-id="element-7" data-mp="28surifc8tji1" />
      </main>
      <Footer data-id="element-8" data-mp="23vck4tdvjcc5" />
    </div>;
}